module.exports = __webpack_public_path__ + "img/icon_waitDevelop.65a90468.png";